// Libraries
import Rill from "rill";
import castJSON from "./utils/cast-json";
import RillCompress from "@rill/compress";
import RillHelmet from "@rill/helmet";
import RillStatic from "@rill/static";
import RillBody from "@rill/body";
import RillFetcher from "@rill/fetcher";
import RillSession from "@rill/session";
import RillAuth from "@rill/auth";
import RillFlash from "@rill/flash";
import RillDelegate from "@rill/delegate";
import RillRefreshWith from "@rill/refresh-with";
import RillLogger from "@rill/logger";
import RillReact from "@rill/react";
import RillProgress from "@rill/progress";
import RillLoader from "@rill/loader";
import CacheBuster from "./middleware/cache-buster";

import TimezoneHelper from "./middleware/time-zone-helper";
import QueryParser from "./middleware/query-parser";
import AppVersion from "./middleware/app-version";
import Load from "./load";
import Middleware from "./middleware";
import Actions from "./actions";
import Wrappers from "./wrappers";
import Views from "./views";
import { AppleAppSiteAssociation } from "./deep-linking/AppleAssociation";

const message = "My Strength Book";

const KEYV_URI =
  process.env.KEYV_URI || "mongodb://localhost:27017/rill-session";

// Initialize app.
if (!process.browser) {
  console.time(message);
  console.log("Running in environment (NODE_ENV): ", process.env.NODE_ENV);
}

const baseFetchUrl = process.browser
  ? window.env?.REACT_APP_API_URL
  : process.env.API_URL;

const app = (module.exports = Rill())
  .use(RillCompress(), TimezoneHelper, AppVersion, QueryParser)
  .use(
    RillHelmet(),
    RillStatic("dist/client", { gzip: true, cache: 6.048e8 }),
    RillBody({ transformField: castJSON }),
    RillFetcher({ name: "api", base: `${baseFetchUrl ?? ""}/api/` }),
    RillSession({
      cache: !process.browser && {
        uri: KEYV_URI,
      },
      keyvTtl: 1000 * 60 * 60 * 24 * 14, // 14 days
    }),
    RillAuth(),
    RillFlash(),
    RillDelegate(),
    RillRefreshWith(),
    RillLogger(),
    RillReact(),
    RillProgress({ color: "#5bc500" }),
    CacheBuster,
    RillLoader()
  )
  .setup(Load, AppleAppSiteAssociation, Middleware, Actions, Wrappers, Views);

if (process.browser) {
  app.listen(() => console.timeEnd(message));
}
